export interface ICreateDeliveryTask {
    orderID: number;
}
